import { strategyToOptions } from "@/common/utils/strategyToOptions";

export const billingEventsFiscalDocumentsStatus = {
  pending: 'Pendente',
  uploaded: 'Aguardando aprovação',
  confirmed: 'Confirmada',
  rejected: 'Rejeitada',
};

export const billingEventsFiscalDocumentsStatusOptions = strategyToOptions(billingEventsFiscalDocumentsStatus);
